import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { PropertiesService } from './properties.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component( {
    selector: 'app-properties',
    templateUrl: './properties.component.html',
    styleUrls: ['./properties.component.css']
} )
export class PropertiesComponent implements OnInit {
    cookieUsername = '';
    propertyNewArr = {};
    submitted = false;
    p = 1;
    propertyFilter: any;
    totalItems: any;
    key: string;
    reverse = false;
    editPropertyId;
    deletePropertyId;
    deletePropertyUserId;
    propertiesForm = new FormGroup( {
        property: new FormControl( '', [Validators.required] ),
        property2: new FormControl(),
        applicant_type: new FormControl( '', [Validators.required] ),
        price: new FormControl()
    } );
    AddPropertyForm = new FormGroup( {
        property: new FormControl( '', [Validators.required] ),
        property2: new FormControl(),
        applicant_type: new FormControl( '', [Validators.required] ),
        price: new FormControl()
    } );
    personClass = {
        'property': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ],
        'price': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ]
    };
    isPricePat;
    isPriceReq;
    isFormValid = false;
    isPriceAddPat;
    isPriceAddReq;
    isFormAddValid = false;
    input;
    propertyInfoArr;
    propertyInfo = [];
    property_id;
    isupdate = false;
    isupdateErr = false;
    updat_msg;
    defaultPrice = 0;
    deletePropertyName;
    propertyId;
    userId;

    constructor( private cookieService: CookieService, private route: ActivatedRoute, private router: Router,
                 private propertyservice: PropertiesService ) {
        this.property_list();
    }

    sort( key ) {
        this.key = key;
        this.reverse = !this.reverse;
    }

    ngOnInit() {
        this.cookieUsername = this.cookieService.get( 'username' );
    }

    onEnterPrice() {

        if ( this.propertiesForm.get( 'price' ).value > 0 ) {

            this.personClass[ 'price' ] = [
                {'success-validate': true, 'error-validate': false},
                {'icon-work-done': true, 'icon-close-border': false}
            ];

        } else {
            this.isFormValid = false;

            this.propertiesForm.get( 'price' ).setValue( '' );
            this.personClass[ 'price' ] = [
                {'success-validate': false, 'error-validate': true},
                {'icon-work-done': false, 'icon-close-border': true}
            ];
        }
    }

    onEnterAddress() {
        if ( this.propertiesForm.get( 'property' ).value.trim() !== '' ) {

            this.isFormValid = true;
            this.personClass[ 'property' ] = [
                {'success-validate': true, 'error-validate': false},
                {'icon-work-done': true, 'icon-close-border': false}
            ];

        } else {

            this.isFormValid = false;
            this.propertiesForm.get( 'property' ).setValue( '' );
            this.personClass[ 'property' ] = [
                {'success-validate': false, 'error-validate': true},
                {'icon-work-done': false, 'icon-close-border': true}
            ];
        }
    }

    onEnterAddPrice() {

        if ( this.AddPropertyForm.get( 'price' ).value > 0 ) {
            this.isFormValid = true;
            this.personClass[ 'price' ] = [
                {'success-validate': true, 'error-validate': false},
                {'icon-work-done': true, 'icon-close-border': false}
            ];

        } else {
            this.isFormValid = false;
            this.AddPropertyForm.get( 'price' ).setValue( '' );
            this.personClass[ 'price' ] = [
                {'success-validate': false, 'error-validate': true},
                {'icon-work-done': false, 'icon-close-border': true}
            ];
        }
    }

    onEnterAddAddress() {
        if ( this.AddPropertyForm.get( 'property' ).value.trim() !== '' ) {

            this.isFormValid = true;
            this.personClass[ 'property' ] = [
                {'success-validate': true, 'error-validate': false},
                {'icon-work-done': true, 'icon-close-border': false}
            ];

        } else {

            this.isFormValid = false;
            this.AddPropertyForm.get( 'property' ).setValue( '' );
            this.personClass[ 'property' ] = [
                {'success-validate': false, 'error-validate': true},
                {'icon-work-done': false, 'icon-close-border': true}
            ];
        }
    }

    property_list() {
        this.propertyInfoArr = [];
        this.propertyInfo = [];
        this.propertyservice.getPropertyInfo()
            .subscribe( post => {
                    this.propertyInfoArr = post;
                    this.isupdateErr = false;
                    const temp = this.propertyInfoArr;

                    for ( let i = 0; i < temp.length; i++ ) {
                        this.propertyNewArr[ temp[ i ].id ] = temp[ i ];
                        this.propertyInfo[ i ] = {'address': {}};
                        this.propertyInfo[ i ].id = temp[ i ].id;
                        this.propertyInfo[ i ].address.address_line1 = temp[ i ].address.address_line1;
                        this.propertyInfo[ i ].address.address_line2 = temp[ i ].address.address_line2;
                        this.propertyInfo[ i ].property_type = temp[ i ].property_type;
                        this.propertyInfo[ i ].property_price = temp[ i ].property_price;
                    }

                    for ( let i = 0; i < this.propertyInfoArr.length; i++ ) {
                        // this.propertyInfo[i]['address_line1'] = this.propertyInfo[i]['address']['address_line1'];
                        // this.propertyInfo[i]['address_line2'] = this.propertyInfo[i]['address']['address_line2'];
                        if ( this.propertyInfo[ i ][ 'address' ][ 'address_line2' ] !== undefined ) {
                            this.propertyInfo[ i ][ 'addressTotal' ] = this.propertyInfo[ i ][ 'address' ][ 'address_line1' ] + ', '
                                + this.propertyInfo[ i ][ 'address' ][ 'address_line2' ];

                        } else {
                            this.propertyInfo[ i ][ 'addressTotal' ] = this.propertyInfo[ i ][ 'address' ][ 'address_line1' ];
                        }
                    }

                    this.propertiesForm.get( 'property' ).setValue( this.propertyInfo[ 0 ].address.address_line1 );
                    if ( this.propertyInfo[ 0 ].address.address_line2 !== '' ) {
                        this.propertiesForm.get( 'property2' ).setValue( this.propertyInfo[ 0 ].address.address_line2 );
                    }

                    this.propertiesForm.get( 'applicant_type' ).setValue( this.propertyInfo[ 0 ].property_type );
                    this.input = this.propertiesForm.get( 'applicant_type' ).value;
                    this.propertiesForm.get( 'price' ).setValue( this.propertyInfo[ 0 ].property_price );
                    this.router.navigate( ['properties'] );
                }
                , error => {
                    // console.log(' error.error.error_msg;', error);
                    if ( error.status === 404 ) {
                        this.isupdateErr = true;
                        this.updat_msg = 'Please add address before starting the assessment.';
                        this.propertyInfo = [];
                    }
                } );
    }

    clearUpdate() {
        this.propertiesForm.reset();
        this.clearValidation();
        this.isupdate = false;
        this.isupdateErr = false;
    }

    submitList( property_id ) {
        const updateObj = this.propertyNewArr[ property_id ];

        updateObj.address.address_line1 = this.propertiesForm.get( 'property' ).value;
        if ( this.propertiesForm.get( 'property2' ).value ) {

            updateObj.address.address_line2 = this.propertiesForm.get( 'property2' ).value;

        } else {
            delete updateObj[ 'address' ].address_line2;
        }

        updateObj.property_type = this.propertiesForm.get( 'applicant_type' ).value;
        // if (this.propertiesForm.get('price').value) {
        updateObj.property_price = ( this.propertiesForm.get( 'price' ).value )
            ? parseInt( this.propertiesForm.get( 'price' ).value ) : this.defaultPrice;

        // }

        delete this.propertyInfo[ 0 ][ 'addressTotal' ];

        this.propertyservice.updatePropertyInfo( property_id, updateObj )
            .subscribe( post => {
                    this.clearForm();
                    this.isupdate = true;
                    this.isupdateErr = false;
                    for ( let i in post ) {
                        if ( i === 'success_msg' ) {
                            this.updat_msg = post[ i ];
                        }
                    }

                    this.property_list();
                    document.getElementById( 'editProperty-popup' ).click();
                },
                error => {
                    // console.log(' error.error.error_msg;');
                    this.isupdate = false;
                    this.isupdateErr = true;
                    this.updat_msg = error.error.error_msg;
                }
            );
    }

    clearForm() {
        this.isupdate = false;
        this.isupdateErr = false;

    }

    saveId( id ) {
        this.updat_msg = '';
        this.isupdate = false;
        this.propertiesForm.get( 'property' ).setValue( this.propertyNewArr[ id ].address.address_line1 );
        this.propertiesForm.get( 'property2' ).setValue( this.propertyNewArr[ id ].address.address_line2 );

        this.propertiesForm.get( 'applicant_type' ).setValue( this.propertyNewArr[ id ].property_type );
        this.propertiesForm.get( 'price' ).setValue( this.propertyNewArr[ id ].property_price );
        this.editPropertyId = id;
    }

    deleteList( id ) {
        const property = this.propertyNewArr[ id ];
        this.updat_msg = '';
        this.isupdate = false;
        this.deletePropertyId = property.id;
        this.deletePropertyName = property.address.address_line2 ? property.address.address_line1 + ', '
            + property.address.address_line2 : property.address.address_line1;
        this.deletePropertyUserId = property.user_id;
    }

    deleteProperty() {
        this.propertyservice.deletePropertyInfo( this.deletePropertyId, this.deletePropertyUserId )
            .subscribe( post => {
                    this.property_list();
                }
                , error => {
                    // console.log(' error.error.error_msg2', error);
                    // this.property_list();
                } );
    }

    clearAdd() {
        this.AddPropertyForm.reset();
        this.clearValidation();
        this.isupdate = false;
        this.isupdateErr = false;
    }

    createProperty() {
        const newProperty = {
            'address': {
                'address_line1': this.AddPropertyForm.get( 'property' ).value.trim(),
            },
            'property_type': this.AddPropertyForm.get( 'applicant_type' ).value,
            'user_id': this.cookieService.get( 'userId' )
        };
        if ( this.AddPropertyForm.get( 'property2' ).value ) {
            newProperty.address[ 'address_line2' ] = this.AddPropertyForm.get( 'property2' ).value.trim();
        }
        if ( this.AddPropertyForm.get( 'price' ).value ) {
            newProperty[ 'property_price' ] = parseInt( this.AddPropertyForm.get( 'price' ).value );

        }
        this.propertyservice.createPropertyInfo( newProperty )
            .subscribe( post => {
                    this.isupdate = true;
                    this.isupdateErr = false;
                    for ( let i in post ) {
                        if ( i === 'success_msg' ) {
                            this.updat_msg = post[ i ];
                        }
                    }
                    this.property_list();
                    document.getElementById( 'addProperty-popup' ).click();
                }
                , error => {
                    // console.log(' error.error.error_msg', error);
                    this.isupdate = false;
                    this.isupdateErr = true;
                    this.updat_msg = error.error.error_msg;
                } );
    }

    onSubmit() {
        this.submitted = true;
        if ( this.propertiesForm.invalid ) {
            return;
        }
    }

    clearValidation() {
        this.personClass = {
            'property': [
                {'success-validate': false, 'error-validate': false},
                {'icon-work-done': false, 'icon-close-border': false}
            ],
            'price': [
                {'success-validate': false, 'error-validate': false},
                {'icon-work-done': false, 'icon-close-border': false}
            ]
        };
        this.AddPropertyForm.reset();
        this.isupdate = false;
        this.isupdateErr = false;
    }

}








